// extracted by mini-css-extract-plugin
export default {"dataItem":"DataItem_dataItem__GONsa","dataItemLabel":"DataItem_dataItemLabel__PeEAC","dataItemValue":"DataItem_dataItemValue__wGif6"};